import ConversationItem from '../conversation_item';
import createModel, { prop } from '../lib/create_model';
import NotificationType from './notification_type';

export default createModel({
  modelName: 'UnofferedCallNotification',

  properties: {
    id: String,
    reason: String,
    conversationItem: prop(ConversationItem),
  },

  overrideToJs(toJs) {
    return () => ({ ...toJs(), type: NotificationType.UNOFFERED_CALL });
  },

  statics: {
    create(attrs) {
      return new this(attrs);
    },
  },
});
